import { InventorySKUListing } from '@views/StockBySKU/components/types';
import { skuUnitNoun } from '../../../utils/sku';
import {
  formatPalletDimensions,
  formatPalletWeight,
  palletVolume,
  skusPerPalletWithUnit,
} from './skuHelpers';

export function SkuPackagingPanel({ sku }: { sku: InventorySKUListing }) {
  const unitNoun = skuUnitNoun(sku);
  const headers = [
    'Pallet type',
    'Dimensions (L × W × H)',
    'SKUs per pallet',
    'Pallet weight',
    'Volume',
  ];

  return (
    <tr className='bg-gray-50'>
      <td colSpan={7} className='px-6 py-4'>
        <p className='mb-2 text-sm font-semibold text-gray-900'>
          Units and packaging{' '}
          <span className='font-normal text-gray-500'>
            · base unit: {unitNoun}
          </span>
        </p>
        <div className='overflow-hidden rounded-lg border border-gray-200 bg-white'>
          <table className='w-full'>
            <thead className='bg-gray-50'>
              <tr>
                {headers.map((header) => (
                  <th
                    key={header}
                    scope='col'
                    className='px-4 py-2 text-left text-xs font-medium text-gray-500'
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='divide-y divide-gray-100'>
              {sku.palletising.map((pallet) => (
                <tr key={pallet.id}>
                  <td className='px-4 py-2 text-sm text-gray-700'>
                    {pallet.type}
                    {pallet.customPalletSpecification && (
                      <span className='ml-1 text-gray-400'>
                        ({pallet.customPalletSpecification})
                      </span>
                    )}
                  </td>
                  <td className='px-4 py-2 text-sm text-gray-700'>
                    {formatPalletDimensions(pallet)}
                  </td>
                  <td className='px-4 py-2 text-sm text-gray-700'>
                    {skusPerPalletWithUnit(sku, pallet)}
                  </td>
                  <td className='px-4 py-2 text-sm text-gray-700'>
                    {formatPalletWeight(pallet)}
                  </td>
                  <td className='px-4 py-2 text-sm text-gray-700'>
                    {palletVolume(pallet)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  );
}
